var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 51.833H39.667C46.667 51.833 51.3337 47.1663 51.3337 40.1663V28.4997C51.3337 22.1997 47.367 17.533 41.5337 16.833C41.067 16.833 40.367 16.833 39.667 16.833H16.3337C15.6337 16.833 15.167 16.833 14.467 17.0663C8.40032 17.7663 4.66699 22.1997 4.66699 28.4997C4.66699 29.1997 4.66699 30.133 4.66699 30.833",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5335 16.8331C41.0668 16.8331 40.3668 16.8331 39.6668 16.8331H16.3335C15.6335 16.8331 15.1668 16.8331 14.4668 17.0664C14.7001 16.3664 15.1668 15.8998 15.8668 15.1998L23.3335 7.4998C26.6001 4.23314 31.7335 4.23314 35.0001 7.4998L39.2001 11.6998C40.6001 13.0998 41.3001 14.9665 41.5335 16.8331Z",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3337 29.667H44.3337C41.767 29.667 39.667 31.767 39.667 34.3337C39.667 36.9003 41.767 39.0003 44.3337 39.0003H51.3337",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.537 50.4334C17.667 50.4334 21.0036 47.0967 21.0036 42.9667C21.0036 38.8367 17.667 35.5 13.537 35.5C9.40699 35.5 6.07031 38.8367 6.07031 42.9667C6.07031 47.0967 9.40699 50.4334 13.537 50.4334Z",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 51.8333L7.00033 49.5",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a9a611540aaac5091f57cfe79b4744bb.svg";
export { ForwardRef as ReactComponent };